export default __webpack_public_path__ + "static/media/no_internet.92d10d6c.png";